export const clearLocalStorageKeysByPrefix = (prefix: string) => {
  if (!prefix) return;

  const keysToRemove = Object.keys(window.localStorage).filter((key) =>
    key.startsWith(prefix)
  );

  for (const key of keysToRemove) {
    window.localStorage.removeItem(key);
  }
};
